import PhoneNumber from 'awesome-phonenumber';
import { REGEX_EMAIL, MINIMAL_PHONE_LENGTH } from '../const/constants';
import { LengthType } from '../Components/models';

export const validateIfExist = (value: string) => !!value;

export const validateLength = (value: string, length: number, type: LengthType) =>
  type === 'min' ? value.length >= length : value.length <= length;

export const validateRegex = (value: string) => REGEX_EMAIL.test(value);

// We are not using it because of "mail confirmation" field deletion
export const compareEmailValues = (currentValue: string, confirmingValue: string) => {
  if (currentValue && confirmingValue) {
    return confirmingValue === currentValue;
  }

  return true;
};

export const validatePhoneNumber = (value, countryCode) => {
  const isCountryCode = value?.length === countryCode?.dialCode?.length;
  const isPhoneValidated = value && value.length > MINIMAL_PHONE_LENGTH;

  if (isCountryCode || !value) {
    return true;
  }

  if (isPhoneValidated) {
    const phoneNumber = new PhoneNumber(`+${value}`);
    const isValidPhone = phoneNumber.isValid();

    return isValidPhone;
  }

  return false;
};

export default {
  validateIfExist,
  validateLength,
  validateRegex,
  compareEmailValues,
  validatePhoneNumber,
};
